import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
// import { ConfigProvider } from 'antd';
// import frFR from 'antd/lib/locale/fr_FR';
import App from './App';
import './index.css';
import './styles/common.less';
import rootReducer from './store/reducers';
import setupInterceptor from './utils/interceptors';
import { ErrorBoundary } from 'react-error-boundary';
import { CapacitorStripeProvider } from '@capacitor-community/stripe/dist/esm/react/provider';

import './i18n';
import Fallback from './components/Fallback';
import { getPlatform } from './utils/helpers';

const initialState = {};

const platform = getPlatform();

const store = createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(thunk),
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()) ||
      compose,
  ),
);
// setup Axios http interceptor
setupInterceptor(store);

if (platform === 'web') {
  ReactDOM.render(
    // <CapacitorStripeProvider publishableKey="pk_test_51JdFwHEcVkgZcwngN8YlCyzBgkMS0ZJ4EXT6QgNKbP4bZm2aFwLGbSTZgaPmXqrC251yrubIhqDYpVQo1z1vqX6J00obS1HSxN">
    <Provider store={store}>
      <ErrorBoundary FallbackComponent={Fallback}>
        <Router>
          <Switch>
            <Route path="/" component={App} />
          </Switch>
        </Router>
      </ErrorBoundary>
    </Provider>,
    // </CapacitorStripeProvider>,
    document.getElementById('root'),
  );
} else {
  ReactDOM.render(
    <CapacitorStripeProvider publishableKey="pk_test_51JdFwHEcVkgZcwngN8YlCyzBgkMS0ZJ4EXT6QgNKbP4bZm2aFwLGbSTZgaPmXqrC251yrubIhqDYpVQo1z1vqX6J00obS1HSxN">
      <Provider store={store}>
        <ErrorBoundary FallbackComponent={Fallback}>
          <Router>
            <Switch>
              <Route path="/" component={App} />
            </Switch>
          </Router>
        </ErrorBoundary>
      </Provider>
    </CapacitorStripeProvider>,
    document.getElementById('root'),
  );
}
